import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVolumeUp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconVolumeUp"><Path d="M13 3.07104V20.9289L5.74656 17H1V6.99999H5.74656L13 3.07104Z" fill="currentColor"/><Path d="M20 11V8H18V11H15V13H18V16H20V13H23V11L20 11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVolumeUp;
